import { render, staticRenderFns } from "./LinkPowerBI.vue?vue&type=template&id=7ba4bfd9"
import script from "./LinkPowerBI.vue?vue&type=script&lang=js"
export * from "./LinkPowerBI.vue?vue&type=script&lang=js"
import style0 from "./LinkPowerBI.vue?vue&type=style&index=0&id=7ba4bfd9&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports